import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Title,
  Copy,
  Bold,
  Card,
  Input,
  Spin
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import { getCustomFilterText } from "app/NativeActions";
class Count extends Component {
  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const {
      token,
      preset,
      preset_object,
      location_type,
      zip,
      city,
      state,
      drawing_coordinates,
      filters,
      location_success,
      preset_success
    } = this.props;

    if (
      preset !== prevProps.preset ||
      preset_object !== prevProps.preset_object ||
      location_type !== prevProps.location_type ||
      zip !== prevProps.zip ||
      city !== prevProps.city ||
      state !== prevProps.state ||
      drawing_coordinates !== prevProps.drawing_coordinates ||
      filters !== prevProps.filters ||
      location_success !== prevProps.location_success ||
      preset_success !== prevProps.preset_success
    ) {
      //get list count
      if (
        preset_success == true &&
        location_success == true &&
        (!this.props.get_list_count_loading || preset !== prevProps.preset)
      ) {
        this.props.updateList({
          token,
          type: "build_list_count",
          location_type,
          zip,
          city,
          state,
          drawing_coordinates,
          filters:
            preset !== null && preset !== -1 && preset_object
              ? preset_object.filter_json
              : filters
        });
      }
    }
  }

  renderCopy() {
    const {
      filters,
      get_list_count,
      get_list_count_loading,
      preset,
      preset_object,
      colors,
      lists_info_banner
    } = this.props;

    if (get_list_count_loading) {
      return (
        <Wrapper style={{ alignItems: "center", justifyContent: "center" }}>
          <Row>
            <Spin size={"small"} />
            <Copy style={{ marginLeft: 10 }}>Estimating Lead Count...</Copy>
          </Row>
        </Wrapper>
      );
    } else if (
      !this.props.route_plan ||
      (this.props.get_list_count > 0 && this.props.get_list_count <= 500)
    ) {
      const filterText =
        preset && preset !== -1 && preset_object
          ? getCustomFilterText(preset_object.filter_json)
          : getCustomFilterText(filters);
      let show_purchase_button = false;
      let lead_count_text =
        get_list_count == 1
          ? `1 lead is estimated to be generated from these parameters. `
          : `${get_list_count} leads are estimated to be generated from these parameters. `;

      const new_list_count =
        parseInt(lists_info_banner.current_count) + parseInt(get_list_count);
      if (
        new_list_count > parseInt(lists_info_banner.limit) &&
        lists_info_banner.limit != -1
      ) {
        show_purchase_button = true;
        const difference = new_list_count - parseInt(lists_info_banner.limit);
        lead_count_text +=
          "This puts your account " +
          difference +
          " leads over your " +
          parseInt(lists_info_banner.limit) +
          " lead limit ";
      }
      return (
        <Wrapper style={{ alignItems: "center", justifyContent: "center" }}>
          <Wrapper
            style={{
              flex: 1,
              padding: 10,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Copy style={{ textAlign: "center" }}>
              <Bold>{lead_count_text}</Bold>
            </Copy>
            {!!filterText ? (
              <Copy style={{ textAlign: "center" }}>({filterText})</Copy>
            ) : null}
          </Wrapper>
          {show_purchase_button ? (
            <PillButton
              primary={true}
              onPress={() => {
                this.props.setPricingPage({
                  title: "Upgrade Engine",
                  engine_slug: "lists",
                  tier: lists_info_banner.next_plan_tier,
                  frequency: "annually"
                });
                this.props.togglePricingPage(true);
              }}
            >
              Upgrade
            </PillButton>
          ) : null}
        </Wrapper>
      );
    }
  }

  renderStartPlan() {
    const { location_success, preset_success } = this.props;
    if (this.props.route_plan && location_success && preset_success) {
      if (
        this.props.get_list_count > 0 &&
        this.props.get_list_count <= 500 &&
        !this.props.get_list_count_loading
      ) {
        return (
          <Row style={{ justifyContent: "center" }}>
            <PillButton
              primary={true}
              onPress={() => {
                this.props.appRedirect({
                  redirect: "start_planned",
                  payload: {
                    filters: this.props.filters,
                    preset: this.props.preset,
                    preset_object: this.props.preset_object,
                    route_plan: true,
                    location_type: this.props.location_type,
                    city: this.props.city,
                    state: this.props.state,
                    zip: this.props.zip,
                    drawing_coordinates: this.props.drawing_coordinates
                  }
                });
              }}
            >
              Start Driving
            </PillButton>
          </Row>
        );
      } else if (
        this.props.get_list_count <= 0 &&
        !this.props.get_list_count_loading
      ) {
        return (
          <Row>
            <Copy style={{ textAlign: "center" }}>
              This planned route has <Bold>0 properties</Bold>. Please change
              your criteria to begin a planned route.
            </Copy>
          </Row>
        );
      } else if (
        this.props.get_list_count > 500 &&
        !this.props.get_list_count_loading
      ) {
        return (
          <Row>
            <Copy style={{ textAlign: "center" }}>
              This planned route has over <Bold>500 properties</Bold>. Please
              change your criteria to limit properties below 500 to begin a
              planned route.
            </Copy>
          </Row>
        );
      }
    }
  }

  render() {
    if (this.props.location_success && this.props.preset_success) {
      return (
        <Wrapper
          style={
            this.props.isMobile && this.props.device == "desktop"
              ? {
                  padding: 20,
                  backgroundColor: this.props.colors.card_color,
                  borderTopWidth: 1,
                  borderTopColor: this.props.colors.border_color,
                  borderTopStyle: "solid",
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  left: 0
                }
              : {
                  padding: 20,
                  backgroundColor: this.props.colors.card_color,
                  borderTopWidth: 1,
                  borderTopColor: this.props.colors.border_color,
                  borderTopStyle: "solid"
                }
          }
        >
          {this.renderCopy()}
          {this.renderStartPlan()}
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default Count;
